import React, { forwardRef } from 'react';
import styles from './Select.module.css';

const Select = forwardRef(({
  label,
  options = [],
  placeholder,
  error,
  helpText,
  required = false,
  multiple = false,
  disabled = false,
  className = '',
  ...props
}, ref) => {
  return (
    <div className={`${styles.selectWrapper} ${className}`}>
      {label && (
        <label className={`${styles.label} ${required ? styles.required : ''}`}>
          {label}
          {required && <span className={styles.asterisk}>*</span>}
        </label>
      )}

      <div className={styles.selectContainer}>
        <select
          ref={ref}
          className={`${styles.select} ${error ? styles.error : ''} ${multiple ? styles.multiple : ''}`}
          disabled={disabled}
          multiple={multiple}
          required={required}
          {...props}
        >
          {placeholder && !multiple && (
            <option value="" >
              {placeholder}
            </option>
          )}

          {options.map((option) => {
            // Handle both simple arrays and object arrays
            const value = typeof option === 'object' ? option.value : option;
            const label = typeof option === 'object' ? option.label : option;
            const disabled = typeof option === 'object' ? option.disabled : false;

            return (
              <option
                key={value}
                value={value}
                disabled={disabled}
              >
                {label}
              </option>
            );
          })}
        </select>

        {!multiple && (
          <div className={styles.arrow}>
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path
                d="M1 1.5L6 6.5L11 1.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>

      {helpText && !error && (
        <span className={styles.helpText}>{helpText}</span>
      )}

      {error && (
        <span className={styles.errorText}>{error}</span>
      )}
    </div>
  );
});

Select.displayName = 'Select';

export default Select;